import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { CHECKOUT_FORM } from '../checkout/store/checkout-forms.state';
import { reducerProvider, reducerToken } from '../checkout/store/reducers/index';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(CHECKOUT_FORM, reducerToken)],
  providers: [reducerProvider, provideHttpClient(withInterceptorsFromDi())],
})
export class CheckoutFormsStoreModule {}
